import { z } from 'zod/v3';

/**
 * Subtitle item with timestamps in milliseconds
 */
export const SubtitleItemSchema = z.object({
  id: z.number(),
  start: z.number(),  // milliseconds
  end: z.number(),    // milliseconds
  text: z.string(),
});

export type SubtitleItem = z.infer<typeof SubtitleItemSchema>;

/**
 * FlowMedia transcript response DTO
 */
export const FlowMediaTranscriptDTOSchema = z.object({
  mediaUrl: z.string(),
  fileName: z.string(),
  duration: z.number().nullable(),
  subtitles: z.array(SubtitleItemSchema),
  vttUrl: z.string().nullable(),
  srtUrl: z.string().nullable(),
});

export type FlowMediaTranscriptDTO = z.infer<typeof FlowMediaTranscriptDTOSchema>;
